<div class="card bg-light">
  <div class="card-header">
    Two-Factor Authentication (2FA)
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-4">
          <a *ngIf="!resettingFactor" [routerLink]="[]" class="text-danger" (click)="reset()"> Reset Two-Factor Authentication </a>
          <span *ngIf="resettingFactor" class="text-danger" > Resetting ... Please wait</span>
        </div>
      </div>
    </div>

  </div>
</div>
